// =============================================
// dateVars — automatyczne zmienne {{current_year}} / {{current_date}}
//
// Generowane artykuly dostawaly zly rok w naglowkach ("2025"), bo model nie
// zna biezacej daty. Kazdy wypelniacz szablonow (promptLoader.fillTemplate,
// promptCompiler.compilePrompt, thematicMapService.fillPromptTemplate) scala
// te zmienne automatycznie: { ...buildDateVars(), ...vars } — vars od
// wywolujacego WYGRYWAJA, wiec recznie podana wartosc nie jest nadpisywana.
//
// Strefa: Europe/Warsaw (data serwera/przegladarki moze byc w UTC — o polnocy
// roznica potrafi przesunac dzien, a 31.12/1.01 nawet rok).
// =============================================

const TZ = "Europe/Warsaw";

/** "2026" — biezacy rok w strefie Europe/Warsaw. */
export function currentYearWarsaw(now: Date = new Date()): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone: TZ, year: "numeric" }).format(now);
}

/** "23 sierpnia 2026" — naturalna polska data (prompty sa po polsku). */
export function currentDateWarsaw(now: Date = new Date()): string {
  return new Intl.DateTimeFormat("pl-PL", {
    timeZone: TZ,
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(now);
}

export function buildDateVars(now: Date = new Date()): Record<string, string> {
  return {
    current_year: currentYearWarsaw(now),
    current_date: currentDateWarsaw(now),
  };
}

/** Scala automatyczne zmienne daty z vars wywolujacego (vars wygrywaja). */
export function withDateVars(vars: Record<string, string>): Record<string, string> {
  return { ...buildDateVars(), ...vars };
}
